import http from "@/http/aisea/axios";
const resource = "enterprises/contracts";

export default {
  getContracts(payload) {
    return http.get(resource, {
      params: payload
    });
  },

  postContracts(payload) {
    return http.post(resource, payload);
  },

  applications(payload) {
    return http.post(`${resource}/applications`, payload);
  },
};
